export default __webpack_public_path__ + "static/media/company.01ecb490.svg";